<div style="display: block;height: 300px;">
    <app-highcharts chartTitle="Uso do Processador %" [data$]="dataSubject"  height="300" yMax="100" valueSuffix=" %"></app-highcharts>
</div>